// extracted by mini-css-extract-plugin
export var customLink = "CustomLink-module--customLink--87911";
export var defaultIcon = "CustomLink-module--defaultIcon--b8cb9";
export var linkBlue = "CustomLink-module--linkBlue--e5b39";
export var linkMedium = "CustomLink-module--linkMedium--05118";
export var linkSmall = "CustomLink-module--linkSmall--89b36";
export var linkTiny = "CustomLink-module--linkTiny--3bea9";
export var linkWhite = "CustomLink-module--linkWhite--85bd8";
export var linkYellow = "CustomLink-module--linkYellow--c0488";
export var lmsScrollbar = "CustomLink-module--lms-scrollbar--40483";
export var navLink = "CustomLink-module--navLink--72431";
export var showTextDecoration = "CustomLink-module--showTextDecoration--8b314";